import { assistaiAppUrl } from "./common/constants/constants.js";
const normalizeHostname = (url) => {
  if (!url.startsWith("http")) {
    url = `https://${url}`;
  }
  return new URL(url).hostname;
};
const currentHostname = window.location.hostname;
const assistAIHostname = normalizeHostname(assistaiAppUrl);

export const isAssistAIURL = currentHostname === assistAIHostname;
const PRODUCT_TITLE = isAssistAIURL ? 'AssistAI' : 'TaskGPT';
localStorage.setItem("isAssistAIURL", isAssistAIURL ? "true" : "false");
const getHostname = (url) => {
    // use URL constructor and return hostname
    return new URL(url).hostname;
}

let host = window.location.origin;
let finalHostName = getHostname(host);


const ENV = {
  base: `https://${finalHostName}/api`,
 //   base: "https://democenter.taskus.com/api",
    botbase: "https://democenter.taskus.com/",
    websocket_url: "wss://democenter.taskus.com/ws/process_file_for_embeddings",
    websocket_receiver: "democenter.taskus",
    websocket_environment: "prod",
    cfFlag: "true",
    product_title: "Demo Center",
    app_title: PRODUCT_TITLE,
    ping: {
      env_id: "ec6cad81-77fb-43ce-ac0d-61c525e12743",
      client_id: "ece030bf-0a6e-4360-8772-fda251a8894a",
      auth_url: "https://auth.pingone.com",
      redirect_uri: "https://democenter.taskus.com",
    },
    smartFloBaseUrl: "https://smartflo.taskus.com",
    smartFloApiBaseUrl: "https://smartflo.taskus.com/api",
    accountID: "3817830",
    trustKey: "3817830",
    agentID: "1386209481",
    licenseKey: "NRBR-ccffa55d87d34bf9829",
    applicationID: "1386209481",
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    sa: 1,
};

export const getEnv = () => {
    return ENV;
};
